import { FC } from "react";
import { Box } from "@chakra-ui/react";

export const HeadButton: FC<{
  onClick: () => void;
  children: string | number;
}> = ({ onClick, children }) => (
  <Box
    as="button"
    padding="20px 50px"
    gap="10px"
    font-weight="700"
    font-size="14px"
    color="#FFFFFF"
    background="#12141A"
    _hover={{ opacity: 0.9 }}
    _active={{
      opacity: 0.7,
    }}
    onClick={onClick}
  >
    {children}
  </Box>
);
